const RESOURCE_TYPES = {
    PODCAST: 'podcast',
    VIDEO: 'video',
    PDF: 'pdf',
    LINK: 'link',
}

export default RESOURCE_TYPES